import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { getCreatorDiscoverySearchStatus, type SearchHistoryResponse } from '../api';

const DEFAULT_REFETCH_INTERVAL = 2_000;

type UseDiscoverySearchStatusOptions = {
  enabled?: boolean;
  refetchInterval?: number;
};

export function isDiscoverySearchTerminal(
  status: Pick<SearchHistoryResponse, 'complete' | 'progress_percentage'> | null | undefined,
) {
  return status?.complete === true || (status?.progress_percentage ?? 0) >= 100;
}

export function useDiscoverySearchStatus(
  discoverySessionId: string | null | undefined,
  searchId: string | null | undefined,
  options?: UseDiscoverySearchStatusOptions,
) {
  const queryKeys = useQueryKeys();
  const sessionId = discoverySessionId ?? '';
  const resolvedSearchId = searchId ?? '';

  return useQuery({
    enabled: sessionId.length > 0 && resolvedSearchId.length > 0 && (options?.enabled ?? true),
    queryKey: queryKeys.discovery.searchStatus(sessionId, resolvedSearchId),
    queryFn: ({ signal }) => getCreatorDiscoverySearchStatus(sessionId, resolvedSearchId, signal),
    refetchInterval: (query) =>
      isDiscoverySearchTerminal(query.state.data)
        ? false
        : (options?.refetchInterval ?? DEFAULT_REFETCH_INTERVAL),
  });
}
